import * as angular from 'angular';

import PreloaderService from './preloader.service';

export const commonUtilModule = angular.module('fp:customerportal:common:util',[])
    .service('preloader', PreloaderService);

export default commonUtilModule;